let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("goT9j")).then(() => parcelRequire('iWYDt'));